import { useDatasourcesStore } from "../stores/datasources";
import { useStringParams } from "./StringParams";

// Fail soft when Pinia isn't active (e.g. during error.vue render)
function getDatasourcesStore() {
  try {
    return useDatasourcesStore();
  } catch {
    return null;
  }
}

export function useMicroCopy(key, params) {
  const store = getDatasourcesStore();
  const item = store?.getEntries?.datasource_entries?.filter((entry) => {
    return entry.name === key;
  });

  let result = item && item.length ? item[0]?.value : null;

  return result === "IS_EMPTY" ? "" : useStringParams(result, params);
}

export function useMicroCopyTagLabel(key) {
  const store = getDatasourcesStore();
  const item = store?.getTagEntries?.datasource_entries?.filter((entry) => {
    return entry.value === key;
  });
  return item && item.length ? item[0]?.dimension_value : "";
}

export function useSettings(key) {
  const store = getDatasourcesStore();

  const item = store?.getSettings?.datasource_entries?.filter((entry) => {
    return entry.name === key;
  });
  return item && item.length ? item[0]?.value : "";
}
